import { render, staticRenderFns } from "./UserQualification.vue?vue&type=template&id=7a67e3fc&"
import script from "./UserQualification.vue?vue&type=script&setup=true&lang=js&"
export * from "./UserQualification.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports